import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { MerchantAccountListItem, AccountStatus, MerchantAccountType } from '../../models';
import { ConfirmationComponent, SetMerchantIdComponent } from '../../modals';
import { MerchantAccountService } from '../../services';

@Component({
    templateUrl: './actions.component.html'
})
export class ActionsComponent implements ICellRendererAngularComp {

    private modalRef: NgbModalRef;
    isAdmin: boolean;
    merchantAccount: MerchantAccountListItem;
    isCashnet: boolean;
    showEditMerchantAccount: boolean = false;
    showEditMerchantId: boolean = false;
    showInactivate: boolean = false;
    showActivate: boolean = false;
    showDelete: boolean = false;

    constructor(
        private modalService: NgbModal,
        private readonly toastr: ToastrService,
        private readonly merchantAccountService: MerchantAccountService
    ) {

    }

    agInit(params: any): void {
        this.isAdmin = params.isAdmin;
        this.merchantAccount = params.data;
        this.isCashnet = this.merchantAccount.merchantAccountType === MerchantAccountType.Cashnet;
        this.showEditMerchantAccount = this.merchantAccount.status !== AccountStatus.Inactive;
        this.showEditMerchantId = (this.merchantAccount.merchantId != null || this.merchantAccount.status === AccountStatus.Complete) && this.merchantAccount.status !== AccountStatus.Inactive;
        this.showInactivate = this.merchantAccount.status === AccountStatus.Finalized;
        this.showActivate = this.merchantAccount.status === AccountStatus.Inactive;
        this.showDelete = this.merchantAccount.status === AccountStatus.Draft;
    }

    refresh(): boolean {
        return false;
    }

    onSetMerchantId() {
        this.modalRef = this.modalService.open(SetMerchantIdComponent);
        this.modalRef.componentInstance.merchantAccount = this.merchantAccount;
        this.modalRef.result.then(() => {
                location.reload();
            },
            () => {
            });
    }

    onInactivate() {
        this.modalRef = this.modalService.open(ConfirmationComponent);
        this.modalRef.componentInstance.text = "Are you sure you want to inactivate this Merchant Account?";
        this.modalRef.result.then((confirm: boolean) => {
            if (confirm) {
                this.merchantAccountService.inactivate(this.merchantAccount.id).subscribe(() => {
                    this.toastr.success("The Merchant Account was successfully inactivated!");
                    location.reload();
                });
            }
        },
        () => {
        });
    }

    onActivate() {
        this.modalRef = this.modalService.open(ConfirmationComponent);
        this.modalRef.componentInstance.text = "Are you sure you want to activate this Merchant Account?";
        this.modalRef.result.then((confirm: boolean) => {
                if (confirm) {
                    this.merchantAccountService.activate(this.merchantAccount.id).subscribe(() => {
                        this.toastr.success("The Merchant Account was successfully activated!");
                        location.reload();
                    });
                }
        },
        () => {
        });
    }

    onDelete() {
        this.modalRef = this.modalService.open(ConfirmationComponent);
        this.modalRef.componentInstance.text = "Are you sure you want to delete this Merchant Account?";
        this.modalRef.result.then((confirm: boolean) => {
                if (confirm) {
                    this.merchantAccountService.delete(this.merchantAccount.id).subscribe(() => {
                        this.toastr.success("The Merchant Account was successfully deleted!");
                        location.reload();
                    });
                }
        },
        () => {
        });
    }
}